export enum EOrientation {
    Horizontal = 'Horizontal',
    Vertical = 'Vertical'
}